import { render, staticRenderFns } from "./bankMovementSplitModal.vue?vue&type=template&id=97d82faa&"
import script from "./bankMovementSplitModal.vue?vue&type=script&lang=ts&"
export * from "./bankMovementSplitModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports